const injectAdditionalProps = (Component, additionalProps) => props => (
  <Component {...additionalProps} {...props} />
);

export default injectAdditionalProps;
